import store from '../store/index';

// 登录
export function routerLogin() {
    const ssoBase = `${store.getters['configuration/ssoBase']}/cn/login2?${encodeURIComponent(window.location.href)}`;
    window.location.replace(ssoBase);
}

// 延迟跳转登录
export function redirectLogin() {
    // 根据产品要求，2 秒再跳转登录
    this.$message.error('未登录，2 秒后跳转登录');
    // 向主站发postMessage
    setTimeout(() => {
        routerLogin();
    }, 2000);
}

export function css(ele, attr) {
    return getComputedStyle(ele, null)[attr];
}

export function offset(ele) {
    const obj = {
        x: ele.offsetLeft + parseInt(css(ele, 'border-left-width')),
        y: ele.offsetTop + parseInt(css(ele, 'border-top-width')),
    };
    let current = ele.offsetParent;
    while (current !== null) {
        obj.x += current.offsetLeft + parseInt(css(current, 'border-left-width'));
        obj.y += current.offsetTop + parseInt(css(current, 'border-top-width'));
        current = current.offsetParent;
    }
    return obj;
}
